// import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
// import * as Yup from 'yup';
// import {
//    Grid,
//    GridItem,
//    // FormControl,
//    // FormErrorMessage,
//    // Input,
//    useColorModeValue,
//    Modal,
//    ModalOverlay,
//    ModalContent,
//    ModalHeader,
//    ModalCloseButton,
//    ModalBody,
//    ModalFooter,
//    Button,
//    // Box,
//    // Stepper,
//    // Step,
//    // StepIndicator,
//    // StepStatus,
//    // StepIcon,
//    // StepNumber,
//    // StepTitle,
//    // StepDescription,
//    // StepSeparator,
//    useToast,
//    // FormLabel,
// } from '@chakra-ui/react';
// import { useDispatch } from 'react-redux';
// import { addDriver, getDriver, updateDriver } from '../../../../../redux/actions/driver';
// import { renderFormControl } from '../../../../../utils/DynamicFormData';
// import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
// import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
// import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
// import { getShareCompanyOptions } from '../../../../../utils/util';
// import { useGlobal } from 'contexts';
// import { useUser } from 'contexts';

// // Yup Validation Schema
// const validationSchema = Yup.object().shape({
//    name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
// });

// // const steps = [
// //   { title: 'First', description: 'Enter Item Information' },
// //   { title: 'Second', description: 'Review and Save' },
// // ];

// const DriverMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, saveandcontinue = true }) => {
//    const [row, setRow] = useState({
//       name: '',
//       compIds: [],
//       // ordinal: ''
//    });
//    const { user } = useUser();
//    const [errors, setErrors] = useState({});
//    const [isLoading, setIsLoading] = useState(false);
//    // const [activeStep, setActiveStep] = useState(0);
//    const toast = useToast();
//    const textColor = useColorModeValue('#9E9E9E', 'white');
//    const dispatch = useDispatch();
//    const { companyList, userGlobalSettingsData } = useGlobal();
//    const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.driver;
//    const shouldShowCompanyDropdown = globalSetting || false;
//    const dbName = localStorage.getItem('dbName');
//    const handleCompanyChange = useCallback((selectedOptions) => {
//       setRow((prev) => ({
//          ...prev,
//          compIds: selectedOptions ?? [],
//       }));
//    }, []);
//    const companyOptions = useMemo(() => {
//       return getShareCompanyOptions({ dbName, company: companyList });
//    }, [companyList, dbName]);

//    const lastcompanyOptions = useMemo(
//       () =>
//          companyOptions.map((company) => ({
//             value: company.value,
//             label: company.label,
//             id: company.value,
//             name: company.label,
//          })),
//       [companyOptions],
//    );

//    // Function to clear form data
//    const clearFormData = () => {
//       setRow({
//          name: '',
//          // ordinal: '',
//       });
//       setErrors({});
//    };

//    useEffect(() => {
//       if (user?.loginhistory?.companyId && !isEditMode) {
//          // Only set if not in edit mode and compIds is empty or doesn't include the user's company
//          setRow((prev) => {
//             if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
//                return {
//                   ...prev,
//                   compIds: [user.loginhistory.companyId],
//                };
//             }
//             return prev;
//          });
//       }
//    }, [user?.loginhistory?.companyId, isEditMode]);

//    // Populate form with current row data when in edit mode
//    useEffect(() => {
//       if (!isEditMode) {
//          clearFormData(); // Clear data when adding a new item
//          setRow((prev) => ({
//             ...prev,
//             compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
//          }));
//       } else if (isEditMode && currentRow) {
//          setRow({
//             name: currentRow.name || '',
//             compIds: currentRow.compIds || [],
//             // ordinal: currentRow.ordinal || '',
//          });
//       }
//    }, [isEditMode, currentRow]);

//    const validateStep = async () => {
//       try {
//          // Validate the whole row object instead of individual fields
//          await validationSchema.validate(row, { abortEarly: false });

//          setErrors({}); // Clear previous errors
//          return true;
//       } catch (err) {
//          if (err instanceof Yup.ValidationError) {
//             const errorObj = {};
//             err.inner.forEach((error) => {
//                errorObj[error.path] = error.message;
//             });
//             setErrors(errorObj);
//             return false;
//          }
//          return false;
//       }
//    };

//    const handleInputChange = (field, value) => {
//       setRow((prev) => ({
//          ...prev,
//          [field]: value,
//       }));

//       // Clear the specific field error when user starts typing
//       setErrors((prevErrors) => {
//          const newErrors = { ...prevErrors };
//          if (newErrors[field]) {
//             delete newErrors[field];
//          }
//          return newErrors;
//       });
//    };

//    // const handleNext = async () => {
//    //   const isValid = await validateStep();
//    //   if (isValid) {
//    //     if (activeStep < steps.length - 1) {
//    //       setActiveStep(activeStep + 1);
//    //     }
//    //   } else {
//    //     toast({
//    //       title: 'Validation Error',
//    //       description: 'Please correct the errors before proceeding.',
//    //       status: 'error',
//    //       duration: 3000,
//    //       isClosable: true,
//    //     });
//    //   }
//    // };

//    // const handlePrevious = () => {
//    //   if (activeStep > 0) {
//    //     setActiveStep(activeStep - 1);
//    //   }
//    // };

//    const onFormSubmit = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          compIds: row.compIds,
//          // ordinal: Number(row.ordinal),
//          // primaryuqcid: Number(row.primaryuqcid),
//          // ratepersalesid: Number(row.ratepersalesid),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateDriver(processedData));
//          } else {
//             // Add new item
//             await dispatch(addDriver(processedData));
//             await dispatch(getDriver());
//          }

//          // Close the modal
//          onClose();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const onsavecontinue = async () => {
//       setIsLoading(true);
//       const processedData = {
//          ...row,
//          // ordinal: Number(row.ordinal),
//          // primaryuqcid: Number(row.primaryuqcid),
//          // ratepersalesid: Number(row.ratepersalesid),
//          // rateperpurchaseid: Number(row.rateperpurchaseid)
//       };

//       try {
//          if (isEditMode && currentRow && currentRow.id) {
//             // Update existing item
//             processedData.id = currentRow.id;
//             await dispatch(updateDriver(processedData));
//          } else {
//             // Add new item
//             await dispatch(addDriver(processedData));
//             await dispatch(getDriver());
//          }
//          clearFormData();
//          setIsLoading(false);
//       } catch (error) {
//          toast({
//             title: 'Error',
//             description: error.message || 'An error occurred while saving the category.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//          setIsLoading(false);
//       }
//    };

//    const handleSubmit = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onFormSubmit(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const handlesavecontinue = async () => {
//       const isValid = await validateStep();
//       if (isValid) {
//          onsavecontinue(); // Call the form submit logic if validation is successful
//       } else {
//          toast({
//             title: 'Validation Error',
//             description: 'Please correct the errors before saving.',
//             status: 'error',
//             duration: 3000,
//             isClosable: true,
//          });
//       }
//    };

//    const nameInputRef = useRef(null);
//    const savefinishRef = useRef(null);
//    useEffect(() => {
//       setTimeout(() => {
//          nameInputRef.current?.focus();
//       }, 100); // small delay sometimes helps
//    }, [isOpen]);

//    useEffect(() => {
//       const handleKeyDown = (e) => {
//          const activeElement = document.activeElement;
//          const isTyping =
//             activeElement?.tagName === 'INPUT' ||
//             activeElement?.tagName === 'TEXTAREA' ||
//             activeElement?.getAttribute('role') === 'textbox' || // for react-select input
//             activeElement?.isContentEditable;

//          if (isTyping) return; // Don't trigger shortcuts while typing

//          if (e.key.toLowerCase() === 's') {
//             if (e.shiftKey) {
//                handlesavecontinue(); // SHIFT + S
//             } else {
//                handleSubmit(); // S only
//             }
//          }
//          if (e.key.toLowerCase() === 'c') {
//             onClose();
//          }
//       };

//       window.addEventListener('keydown', handleKeyDown);

//       return () => {
//          window.removeEventListener('keydown', handleKeyDown);
//       };
//    }, [validateStep]);

//    useEffect(() => {
//       const handleEsc = (e) => {
//          if (e.key === "Escape") {
//             e.preventDefault();
//             onClose();
//          }
//       };

//       document.addEventListener("keydown", handleEsc);
//       return () => {
//          document.removeEventListener("keydown", handleEsc);
//       };
//    }, [onClose]);

//    return (
//       <Modal isOpen={isOpen} onClose={onClose} size="3xl">
//          <ModalOverlay />
//          <ModalContent
//             bg={useColorModeValue('white', '#2d3748')}
//             color={useColorModeValue('gray.800', 'white')}
//             borderRadius="20px"
//             p={0}
//             mx="15px"
//             mt={{ base: '50%', md: '20%', xl: '15%' }}
//             boxShadow="lg">
//             <ModalHeader fontSize="20px" fontWeight="600" mb={{ base: 0, xl: 4 }}>
//                {isEditMode ? 'Edit Driver' : 'Add New Drive'}
//             </ModalHeader>
//             <ModalCloseButton />
//             <ModalBody>
//                {/* <Stepper index={activeStep} colorScheme="teal">
//             {steps.map((step, index) => (
//               <Step key={index}>
//                 <StepIndicator>
//                   <StepStatus
//                     complete={<StepIcon />}
//                     incomplete={<StepNumber />}
//                     active={<StepNumber />}
//                   />
//                 </StepIndicator>
//                 <Box flexShrink="0">
//                   <StepTitle>{step.title}</StepTitle>
//                   <StepDescription>{step.description}</StepDescription>
//                 </Box>
//                 <StepSeparator />
//               </Step>
//             ))}
//           </Stepper> */}

//                {/* {activeStep === 0 && ( */}
//                <Grid templateColumns={{ base: 'repeat(1, 1fr)', md: 'repeat(1, 1fr)', xl: 'repeat(1, 1fr)' }} gap={6}>
//                   <GridItem colSpan={1}>
//                      {DynamicInput(
//                         'name',
//                         'Name',
//                         {
//                            value: row.name,
//                            onChange: (e) => handleInputChange('name', e.target.value),
//                            ref: nameInputRef,
//                            onKeyDown: (e) => {
//                               if (e.key === 'Enter' || e.key === 'Tab') {
//                                  e.preventDefault();
//                                  savefinishRef.current?.focus(); // Focus Apply GST
//                               }
//                            },
//                         },
//                         errors,
//                         textColor,
//                         'text',
//                         true, // optional: mark as required
//                      )}
//                   </GridItem>
//                   {shouldShowCompanyDropdown && (
//                      <GridItem className="seperator-width">
//                         {renderDynamicUiDropdown(
//                            'company',
//                            'Company',
//                            lastcompanyOptions,
//                            {
//                               value: row.compIds,
//                               onChange: handleCompanyChange,
//                            },
//                            {},
//                            textColor,
//                            false,
//                            'Select company',
//                            true,
//                            undefined,
//                            true,
//                         )}
//                      </GridItem>
//                   )}
//                </Grid>
//                {/* )} */}

//                {/* {activeStep === 1 && (
//             <Box mt={8}>
//               <strong>Name:</strong> {row.name}
//               <br />
//             </Box>
//           )} */}
//             </ModalBody>
//             <ModalFooter>
//                {/* {activeStep > 0 && (
//             <Button
//               onClick={handlePrevious}
//               variant="ghost"
//               colorScheme="teal"
//               mr={3}
//             >
//               Previous
//             </Button>
//           )}

//           {activeStep < steps.length - 1 && (
//             <Button onClick={handleNext} colorScheme="teal">
//               Next
//             </Button>
//           )} */}
//                {!isEditMode && saveandcontinue === true && (
//                   <Button
//                      onClick={handlesavecontinue}
//                      isLoading={isLoading}
//                      disabled={isLoading}
//                      colorScheme="green"
//                      ml={3}
//                      _focus={{ outlineColor: 'blue.500 ' }}>
//                      save & continue
//                   </Button>
//                )}
//                <Button
//                   onClick={handleSubmit}
//                   isLoading={isLoading}
//                   disabled={isLoading}
//                   ref={savefinishRef}
//                   colorScheme="green"
//                   ml={3}
//                   _focus={{ outlineColor: 'blue.500 ' }}>
//                   Save & Finish
//                </Button>

//                <Button variant="ghost" onClick={onClose} ml={3} _focus={{ outlineColor: 'blue.500 ' }}>
//                   Cancel
//                </Button>
//             </ModalFooter>
//          </ModalContent>
//       </Modal>
//    );
// };

// export default DriverMasterForm;

import React, { useState, useEffect, useRef, useCallback, useMemo } from 'react';
import * as Yup from 'yup';
import {
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalCloseButton,
   ModalBody,
   ModalFooter,
   Button,
   useToast,
   useColorMode,
} from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { addDriver, getDriver, updateDriver } from '../../../../../redux/actions/driver';
import { renderFormControl } from '../../../../../utils/DynamicFormData';
import { DynamicInput } from 'components/UIcomponents/Dynamicinput';
import { renderDynamicDropdown } from 'components/UIcomponents/DynamicDropdown';
import { renderDynamicDropdown as renderDynamicUiDropdown } from 'components/ui/DynamicDropdown';
import { getShareCompanyOptions } from '../../../../../utils/util';
import { useGlobal } from 'contexts';
import { useUser } from 'contexts';

// Yup Validation Schema
const validationSchema = Yup.object().shape({
   name: Yup.string().required('Name is required').min(1, 'Name must be at least 1 characters long'),
});

const DriverMasterForm = ({ isOpen, onClose, isEditMode = false, currentRow = null, saveandcontinue = true }) => {
   const { colorMode } = useColorMode();
   const isDark = colorMode === 'dark';

   const [row, setRow] = useState({
      name: '',
      compIds: [],
   });
   const { user } = useUser();
   const [errors, setErrors] = useState({});
   const [isLoading, setIsLoading] = useState(false);
   const toast = useToast();
   const dispatch = useDispatch();
   const { companyList, userGlobalSettingsData } = useGlobal();
   const globalSetting = userGlobalSettingsData?.[0]?.askCompany?.driver;
   const shouldShowCompanyDropdown = globalSetting || false;
   const dbName = localStorage.getItem('dbName');

   const handleCompanyChange = useCallback((selectedOptions) => {
      setRow((prev) => ({
         ...prev,
         compIds: selectedOptions ?? [],
      }));
   }, []);

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   const lastcompanyOptions = useMemo(
      () =>
         companyOptions.map((company) => ({
            value: company.value,
            label: company.label,
            id: company.value,
            name: company.label,
         })),
      [companyOptions],
   );

   const clearFormData = () => {
      setRow({
         name: '',
      });
      setErrors({});
   };

   useEffect(() => {
      if (user?.loginhistory?.companyId && !isEditMode) {
         setRow((prev) => {
            if (prev.compIds.length === 0 || !prev.compIds.includes(user.loginhistory.companyId)) {
               return {
                  ...prev,
                  compIds: [user.loginhistory.companyId],
               };
            }
            return prev;
         });
      }
   }, [user?.loginhistory?.companyId, isEditMode]);

   useEffect(() => {
      if (!isEditMode) {
         clearFormData();
         setRow((prev) => ({
            ...prev,
            compIds: user?.loginhistory?.companyId ? [user.loginhistory.companyId] : [],
         }));
      } else if (isEditMode && currentRow) {
         setRow({
            name: currentRow.name || '',
            compIds: currentRow.compIds || [],
         });
      }
   }, [isEditMode, currentRow]);

   const validateStep = async () => {
      try {
         await validationSchema.validate(row, { abortEarly: false });
         setErrors({});
         return true;
      } catch (err) {
         if (err instanceof Yup.ValidationError) {
            const errorObj = {};
            err.inner.forEach((error) => {
               errorObj[error.path] = error.message;
            });
            setErrors(errorObj);
            return false;
         }
         return false;
      }
   };

   const handleInputChange = (field, value) => {
      setRow((prev) => ({
         ...prev,
         [field]: value,
      }));

      setErrors((prevErrors) => {
         const newErrors = { ...prevErrors };
         if (newErrors[field]) {
            delete newErrors[field];
         }
         return newErrors;
      });
   };

   const onFormSubmit = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
         compIds: row.compIds,
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateDriver(processedData));
         } else {
            await dispatch(addDriver(processedData));
            await dispatch(getDriver());
         }

         onClose();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const onsavecontinue = async () => {
      setIsLoading(true);
      const processedData = {
         ...row,
      };

      try {
         if (isEditMode && currentRow && currentRow.id) {
            processedData.id = currentRow.id;
            await dispatch(updateDriver(processedData));
         } else {
            await dispatch(addDriver(processedData));
            await dispatch(getDriver());
         }
         clearFormData();
         setIsLoading(false);
      } catch (error) {
         toast({
            title: 'Error',
            description: error.message || 'An error occurred while saving the category.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
         setIsLoading(false);
      }
   };

   const handleSubmit = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onFormSubmit();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const handlesavecontinue = async () => {
      const isValid = await validateStep();
      if (isValid) {
         onsavecontinue();
      } else {
         toast({
            title: 'Validation Error',
            description: 'Please correct the errors before saving.',
            status: 'error',
            duration: 3000,
            isClosable: true,
         });
      }
   };

   const nameInputRef = useRef(null);
   const savefinishRef = useRef(null);
   const cancelRef = useRef(null);
   const savecontinueRef = useRef(null);

   useEffect(() => {
      setTimeout(() => {
         nameInputRef.current?.focus();
      }, 100);
   }, [isOpen]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const activeElement = document.activeElement;
         const isTyping =
            activeElement?.tagName === 'INPUT' ||
            activeElement?.tagName === 'TEXTAREA' ||
            activeElement?.getAttribute('role') === 'textbox' ||
            activeElement?.isContentEditable;

         if (isTyping) return;

         if (isOpen && e.key.toLowerCase() === 's') {
            if (e.shiftKey) {
               handlesavecontinue();
            } else {
               handleSubmit();
            }
         }
         if (isOpen && e.key.toLowerCase() === 'c') {
            onClose();
         }
      };

      window.addEventListener('keydown', handleKeyDown);
      return () => {
         window.removeEventListener('keydown', handleKeyDown);
      };
   }, [validateStep]);

   useEffect(() => {
      const handleEsc = (e) => {
         if (e.key === 'Escape') {
            e.preventDefault();
            onClose();
         }
      };

      document.addEventListener('keydown', handleEsc);
      return () => {
         document.removeEventListener('keydown', handleEsc);
      };
   }, [onClose]);

   return (
      <Modal isOpen={isOpen} onClose={onClose} size="3xl">
         <ModalOverlay className="backdrop-blur-sm bg-black/30" />
         <ModalContent
            className={`
               ${isDark ? 'bg-gray-800' : 'bg-white'}
               rounded-2xl shadow-2xl mx-4
               ${isDark ? 'border border-gray-700' : 'border border-gray-200'}
            `}
            style={{ marginTop: window.innerWidth < 768 ? '50%' : window.innerWidth < 1280 ? '20%' : '15%' }}>
            {/* Header with gradient - Driver Theme (Purple/Violet) */}
            <ModalHeader
               className={`
                  text-xl font-semibold py-5 px-6 rounded-t-2xl
                  ${isDark
                     ? 'bg-gradient-to-r from-purple-900 to-violet-900 text-white border-b border-gray-700'
                     : 'bg-gradient-to-r from-purple-50 to-violet-50 text-gray-800 border-b border-purple-200'
                  }
               `}>
               <div className="flex items-center gap-3">
                  <div
                     className={`w-10 h-10 rounded-lg flex items-center justify-center ${isDark ? 'bg-purple-800' : 'bg-purple-500'
                        }`}>
                     <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path
                           strokeLinecap="round"
                           strokeLinejoin="round"
                           strokeWidth={2}
                           d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
                        />
                     </svg>
                  </div>
                  <span>{isEditMode ? 'Edit Driver' : 'Add New Driver'}</span>
               </div>
            </ModalHeader>

            <ModalCloseButton
               className={`${isDark ? 'text-gray-300 hover:text-white' : 'text-gray-600 hover:text-gray-800'} mt-2`}
            />

            <ModalBody className="p-6">
               {/* Driver Information Section */}
               <div className="mb-6">
                  <div
                     className={`
                     flex items-center gap-2 mb-4 pb-2 border-b-2
                     ${isDark ? 'border-purple-700' : 'border-purple-300'}
                  `}>
                     <div
                        className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-purple-900' : 'bg-purple-100'
                           }`}>
                        <svg
                           className={`w-5 h-5 ${isDark ? 'text-purple-300' : 'text-purple-600'}`}
                           fill="none"
                           stroke="currentColor"
                           viewBox="0 0 24 24">
                           <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M5.121 17.804A13.937 13.937 0 0112 16c2.5 0 4.847.655 6.879 1.804M15 10a3 3 0 11-6 0 3 3 0 016 0zm6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                           />
                        </svg>
                     </div>
                     <h3 className={`text-lg font-semibold ${isDark ? 'text-purple-300' : 'text-purple-700'}`}>
                        Driver Information
                     </h3>
                  </div>

                  <div className="space-y-4">
                     <div
                        className={`
                        p-5 rounded-xl transition-all duration-200
                        ${isDark
                              ? 'bg-gray-900 border border-gray-700 hover:border-purple-600 hover:shadow-lg hover:shadow-purple-900/20'
                              : 'bg-purple-50/30 border border-purple-200 hover:border-purple-400 hover:shadow-lg hover:shadow-purple-500/10'
                           }
                     `}>
                        {DynamicInput(
                           'name',
                           'Name',
                           {
                              value: row.name,
                              onChange: (e) => handleInputChange('name', e.target.value),
                              ref: nameInputRef,
                              onKeyDown: (e) => {
                                 if (e.key === 'Enter' || e.key === 'Tab') {
                                    e.preventDefault();
                                    savefinishRef.current?.focus();
                                 }
                              },
                           },
                           errors,
                           isDark ? '#9E9E9E' : '#4B5563',
                           'text',
                           true,
                        )}
                     </div>
                  </div>
               </div>

               {/* Company Account Section */}
               {shouldShowCompanyDropdown && (
                  <div>
                     <div
                        className={`
                        flex items-center gap-2 mb-4 pb-2 border-b-2
                        ${isDark ? 'border-amber-700' : 'border-amber-300'}
                     `}>
                        <div
                           className={`w-8 h-8 rounded-lg flex items-center justify-center ${isDark ? 'bg-amber-900' : 'bg-amber-100'
                              }`}>
                           <svg
                              className={`w-5 h-5 ${isDark ? 'text-amber-300' : 'text-amber-600'}`}
                              fill="none"
                              stroke="currentColor"
                              viewBox="0 0 24 24">
                              <path
                                 strokeLinecap="round"
                                 strokeLinejoin="round"
                                 strokeWidth={2}
                                 d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"
                              />
                           </svg>
                        </div>
                        <h3 className={`text-lg font-semibold ${isDark ? 'text-amber-300' : 'text-amber-700'}`}>
                           Company Account
                        </h3>
                     </div>

                     <div
                        className={`
                        p-5 rounded-xl transition-all duration-200
                        ${isDark
                              ? 'bg-gray-900 border border-gray-700 hover:border-amber-600 hover:shadow-lg hover:shadow-amber-900/20'
                              : 'bg-amber-50/30 border border-amber-200 hover:border-amber-400 hover:shadow-lg hover:shadow-amber-500/10'
                           }
                     `}>
                        {renderDynamicUiDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: row.compIds,
                              onChange: handleCompanyChange,
                           },
                           {},
                           isDark ? '#9E9E9E' : '#4B5563',
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </div>
                  </div>
               )}
            </ModalBody>

            <ModalFooter
               className={`
               p-6 rounded-b-2xl border-t
               ${isDark
                     ? 'bg-gray-900 border-gray-700'
                     : 'bg-gradient-to-r from-purple-50/50 to-violet-50/50 border-purple-200'
                  }
            `}>
               <div className="flex gap-3 flex-wrap justify-end w-full">
                  {!isEditMode && saveandcontinue === true && (
                     <Button
                        ref={savecontinueRef}
                        onClick={handlesavecontinue}
                        isLoading={isLoading}
                        disabled={isLoading}
                        className={`
                           px-6 py-2 rounded-lg font-medium transition-all duration-200
                           ${isDark
                              ? 'bg-violet-600 hover:bg-violet-700 text-white shadow-lg shadow-violet-900/50 hover:shadow-violet-900/70'
                              : 'bg-violet-500 hover:bg-violet-600 text-white shadow-lg shadow-violet-500/30 hover:shadow-violet-500/50'
                           }
                        `}
                        _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                        colorScheme="purple"
                        onKeyDown={(e) => {
                           if (e.key === 'ArrowRight') {
                              e.preventDefault();
                              savefinishRef.current?.focus();
                           }
                        }}>
                        Save & Continue
                     </Button>
                  )}

                  <Button
                     onClick={handleSubmit}
                     isLoading={isLoading}
                     disabled={isLoading}
                     ref={savefinishRef}
                     className={`
                        px-6 py-2 rounded-lg font-medium transition-all duration-200
                        ${isDark
                           ? 'bg-purple-600 hover:bg-purple-700 text-white shadow-lg shadow-purple-900/50 hover:shadow-purple-900/70'
                           : 'bg-purple-500 hover:bg-purple-600 text-white shadow-lg shadow-purple-500/30 hover:shadow-purple-500/50'
                        }
                     `}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                     colorScheme="purple"
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowRight') {
                           e.preventDefault();
                           cancelRef.current?.focus();
                        } else if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           if (!isEditMode && saveandcontinue === true) {
                              savecontinueRef.current?.focus();
                           }
                        }
                     }}>
                     Save & Finish
                  </Button>

                  <Button
                     ref={cancelRef}
                     variant="ghost"
                     onClick={onClose}
                     className={`
                        px-6 py-2 rounded-lg font-medium transition-all duration-200
                        ${isDark
                           ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
                           : 'text-gray-700 hover:bg-purple-100 hover:text-gray-900'
                        }
                     `}
                     _focus={{ boxShadow: '0 0 0 3px rgba(59, 130, 246, 0.4)' }}
                     onKeyDown={(e) => {
                        if (e.key === 'ArrowLeft') {
                           e.preventDefault();
                           savefinishRef.current?.focus();
                        }
                     }}>
                     Cancel
                  </Button>
               </div>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );
};

export default DriverMasterForm;
